import React, { useState, useEffect } from "react"
import _ from 'lodash'
import { field_attrs } from "components/table/lib/column-field"

import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput } from "components/table/carousel/inputs"

const OccupiedRolloverBasic = (props: {rowData: [], field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    spreadMos: null,
    percentRollToMarket: null
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field])

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'spreadEvenly') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val: number, field: string):void {
    let nextData = _.cloneDeep(data);
    nextData[field] = val
    setData(nextData)
    props.persist({...nextData, state: 'spreadEvenly'}, props.field, props.rowData)
  }

  const attrs = (field) => field_attrs('multifamily', props.field)(field)(props.rowData, props)

  return (
    <div>
      <NoneStateTrashIcon />
      <SingleRowCarouselState_s>
        <div>
          <label>Spread Period (Mos)</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="spreadMos" readPrecision={0} writePrecision={0} persist={updateData} />
        </div>
        <div>
          <label>% Roll To Market</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="percentRollToMarket" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default OccupiedRolloverBasic
